import { render } from "./SimpleLabel.vue?vue&type=template&id=e4ac8fd4&scoped=true&ts=true"
import script from "./SimpleLabel.vue?vue&type=script&lang=ts"
export * from "./SimpleLabel.vue?vue&type=script&lang=ts"

import "./SimpleLabel.vue?vue&type=style&index=0&id=e4ac8fd4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4ac8fd4"]])

export default __exports__